// @ts-nocheck
const BaseButton = ({
  title,
  id = "",
  variant = "primary",

  onClick = e => e,
  disabled = false,
  ariaLabel = "",
  classContainer = "",
  classBtn = "",
  isLoading,
  type = "button",
}) => {
  const getPrimaryOrSecondary = variant => {
    if (variant.includes("primary")) {
      return "primary";
    }
    return "secondary";
  };

  const getTypeButton = typeX => {
    const types = {
      primary: "btn-primary-1",
      primary2: "btn-primary-2",
      primary3: "btn-primary-3",
      secondary: "btn-secondary-1",
      secondary2: "btn-secondary-2",
      secondary3: "btn-secondary-3",
    };
    return types[typeX];
  };

  return (
    <div className={`${classContainer} btn-container`}>
      <button
        type={type}
        className={`btn-${getPrimaryOrSecondary(variant)} ${getTypeButton(variant)} ${classBtn}`}
        onClick={onClick}
        disabled={disabled || isLoading}
        aria-label={ariaLabel}
        id={id}
      >
        {title}
      </button>
    </div>
  );
};

export default BaseButton;
